import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Collaborative Effort',
  date: new Date(2023, 8, 17),
  img: '/img/god.jpeg',
  tracks: [
    {
      title: 'Sand in My Eyes',
      src: '/songs/2023-09-17/sand_in_my_eyes.mp3',
    },
    {
      title: 'Petrichor',
      src: '/songs/2023-09-17/petrichor.mp3',
    },
    {
      title: 'A Sleepwalker\'s Tale',
      src: '/songs/2023-09-17/a_sleepwalkers_tale.mp3',
    },
    {
      title: 'Growing Pains',
      src: '/songs/2023-09-17/growing_pains.mp3',
    },
    {
      title: 'One Thoroughly Dope-Ass Jam',
      src: '/songs/2023-09-17/one_thoroughly_dope_ass_jam.mp3',
    },
    {
      title: 'Baby I Need You (More than you need me)',
      src: '/songs/2023-09-17/baby_i_need_you.mp3',
    },
    {
      title: 'Sometimes you just can\'t Tell',
      src: '/songs/2023-09-17/sometimes_you_just_cant_tell.mp3',
    },
    {
      title: 'Let me Fly',
      src: '/songs/2023-09-17/let_me_fly.mp3',
    },
    {
      title: 'I\'m a Man',
      src: '/songs/2023-09-17/im_a_man.mp3',
    },
    {
      title: 'Religion & Drugs (Are a Dangerous Mix)',
      src: '/songs/2023-09-17/religion_and_drugs.mp3',
    },
    {
      title: 'Big, Strong Robots',
      src: '/songs/2023-09-17/big_strong_robots.mp3',
    },
    {
      title: 'How Not to keep a Girlfriend',
      src: '/songs/2023-09-17/how_not_to_keep_a_girlfriend.mp3',
    },
    {
      title: 'Welcome to The Psyche Ward',
      src: '/songs/2023-09-17/welcome_to_the_psyche_ward.mp3',
    },
  ]
}
export default album;